import React, { useContext, useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import questions from "../../utils/translation/en.json";
import Button from "../../storybook/Button";
import savedAnswerKeys from "./schema.json";
import BackModal from "../Modal/BackModal";
import ExitModalAndSave from "../Modal/ExitModalAndSave";
import { useDispatch, useSelector } from "react-redux";
import * as api from "../../api";
import Loader from "react-loader-spinner";
import "../../compositions/ConfirmationPage/index.scss";
import moment from "moment";
import {
  userChosenPropertyId,
  userChosenPropertyType,
  userChosenPropertyAddress,
  userChosenRepairLocationId,
  userChosenRepairLocation,
  userChosenHighLevelDescription,
  userChosenSupplementaryQuestions,
  userChosenAdditionalDescription,
  userChosenVandalismQuestion,
  userChosenVandalismAdditionalInformation,
  userChosenCovidQuestion,
  userChosenContactDetails,
  userChosenSTATUS,
  userChosenEligibilityErrorCode,
  userChosenContactPhone,
  userChosenContactName,
  userChosenRelationDetails,
  updatePrevConfirmedState,
  isEditState,
  userChosenResumeRepair,
  loadDuplicateRepairPage,
  userCreatedNewRepair,
  clearMediaFiles,
  isOnHoldRepair,
  showFooter,
  userGetRepairData,
  setWorkOrderApiFailureMessage,
  saveEmailCopyRadioValue,
  saveAlternateEmailValue,
  isSendCopyDampMouldReport,
  userChosenVulnerabilityAdditionalInformation,
  calendarPageIndex,
  originalRepairAppointmentWillNotBeCreated,
  dmcRepairAppointmentWillNotBeCreated,
  repairPriorityValue
} from "../../ducks/redux/actions/userChoices";
import {
  getContractorName,
  workOrderRepairObject,
  getDeterminedContractorDetails,
  dmcWorkOrderRepairObject
} from "../../ducks/redux/actions/getAddress";
import { WorksOrderRequest } from "../../models/WorksOrders/WorksOrderRequest";
import { CatalistTriageContractorType, EMAContractorType } from "../../models/Repair/Contractor";
import { FeatureFlags } from "../contexts/FeatureFlags";
import HeaderJourney from "../../storybook/Header/HeaderJourney";
import Message from "../../storybook/Message";
import { comingFromRepairJourneySuccess, isContinueButtonDisabled, setTriageRepair } from "../../ducks/redux/actions/FinancialReferral";
import { RepairChannel } from "../../models/Repair/RepairChannel";
import { isNullOrUndefined } from "../../utils/formatting";
import { CASE_IDENTIFIER } from "../../ducks/redux/actionTypes";
import { CasePriority, RepairPriorityCode } from '../../models/Repair/RepairPriority';
import LoaderPopup from "../LoaderPage";
import { isUndefinedNullOrEmpty } from "../../utils/translation/helper";
import { saveHHSRSAssessmentCompleted } from "../../ducks/redux/actions/hazardAssessment";
import { Helper } from "../../utils/Helper/HelperUtil";

export const buildPreAssessmentNoteText = async (
  responses: any[],
  assessmentOutcome?: any,
  selectedRepairReasonObject?: any[],
  isHHSRSAssessmentCompleted?: boolean,
): Promise<string> => {
  const completedResponses = (responses || [])
    .filter((response: any) => response?.isPreAssessment && response?.answers?.length)
    .sort((first: any, second: any) => first.sequence - second.sequence);

    const noteHeader="HHSRS Pre Assessment";

  if (!completedResponses.length) {
    return "";
  }

  const questionLines = completedResponses.flatMap((response: any, index: number) => {
    const questionNumber = index + 1;
    return [
      `Question ${questionNumber}: ${response.question}`,
      `Question ${questionNumber} Answer(s): ${response.answers.join(", ")}`,
    ];
  });

  const hazardType = assessmentOutcome?.hazardType || selectedRepairReasonObject?.[0]?.hazardType || "";
  const hazardName = (await api.getHazardNameByType(hazardType)) ?? hazardType;
  const triageType = hazardName.toLowerCase().includes("triage")
    ? hazardName
    : `${hazardName} Triage Hazard`;
 

  const noteLines = [
    noteHeader,
    ...questionLines,
    `Outcome: ${isHHSRSAssessmentCompleted ? triageType : "Standard Repair"}`,
  ];

  return noteLines.join("\n");
};

const ConfirmationDetails: React.FC<any> = (props) => {
  let saveIndex: number = 0;
  const savedResponses = useSelector((state: any) => state.userChoicesReducer);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { featureMedia }: any = useContext(FeatureFlags);
  const [dmcQuestions, setDmcQuestions] = useState<any>();
  enum RepairCauseId {
    "General Wear and Tear" = 1,
    "Vandalism or Damage" = 4,
  }
  enum AssetType {
    "Property" = "Property",
    "Block" = "Block"
  }
  const checkEnhancedEligibility = useSelector(
    (state: any) =>
      state.userChoicesReducer.checkEnhancedRepairEligibilityMyPeabody
  );
  const determinedcontractordetails = useSelector(
    (state: any) => state.addresses?.determinedcontractordetails
  );
  const userChosenSupplementaryQuestionsVal = useSelector(
    (state: any) => state.userChoicesReducer.userChosenSupplementaryQuestions
  );
  const userChosenVandalismQuestionVal = useSelector(
    (state: any) => state.userChoicesReducer.userChosenVandalismQuestion
  );
  const userChosenCovidQuestionVal = useSelector(
    (state: any) => state.userChoicesReducer.userChosenCovidQuestion
  );
  const covidConfigValue = useSelector(
    (state: any) => state?.addresses?.covidtoggleValue
  );
  const isCatalyst = useSelector(
    (state: any) => state.userChoicesReducer?.isCatalystCustomer
  );
  const eligibilityResponseObject = useSelector(
    (state: any) =>
      state?.dashboardReducer?.formState?.eligibilityResponseObject
  );
  const selectedRepairReasonObject = useSelector(
    (state: any) =>
      state?.dashboardReducer?.formState?.selectedRepairReasonObject
  );
  const boroughName = useSelector(
    (state: any) => state.userChoicesReducer.borough
  );
  const getRiskRating = useSelector((state:any) => state.hazard?.hazardPostAccessResponse);
  const [isLoading, setIsLoading] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [closeAfterSaving, setCloseAfterSaving] = useState(false);
  const [BlockMsg, setBlockMsg] = useState<any>();
  const [blockLoading, setBlockLoading] = useState(false);
  const [blockErrorCode, setBlockErrorCode] = useState("");
  const [dmcWOContractorResponse, setdmcOriginalWOContractorResponse] = useState<any | null>(null);
  const [dmcoriginalWOPriorityResponse, setdmcoriginalWOPriorityResponse] = useState<any | null>(null);
  const [showDMLPreferenceQuestion, setShowDMLPreferenceQuestion] = useState(false);
  let dmcQuestionsFromReducer = useSelector((state: any) => state?.financialReferralReducer?.DMCData);
  const dmcAnswersFromReducer = useSelector((state: any) => state?.financialReferralReducer?.DMCAnsData);
  const saveDampReport = useSelector((state: any) => state?.userChoicesReducer?.userChosenSaveDampReport);
  const getEmailCopyValue = useSelector(
    (state: any) => state?.userChoicesReducer?.userChosenEmailCopyRadioValue
  );
  const alternateEmailValue = useSelector((state: any) => state?.userChoicesReducer?.userChosenAlternateEmailValue);
  const workOrderObject = useSelector(
    (state: any) => state.addresses.workOrderRepair
  );
  const hazardResponses = useSelector((state: any) => state?.hazard?.responses || []);
  const assessmentOutcome = useSelector((state: any) => state?.hazard?.assessment || null);
  const isHHSRSAssessmentCompleted = useSelector(
    (state: any) => state.hazard?.isHHSRSAssessmentCompleted
  );
  const [loaderPage, setLoaderPage] = useState(false);

  const isDMCEnabledtoggleValue = useSelector(
    (state: any) => state?.addresses?.isDMCEnabledtoggleValue
  );
  const ValueCustomerPreferences = useSelector(
    (state: any) => state?.userChoicesReducer?.checkToggleValueCustomerPreferences
  );
  const HHSRSToggleForCustomerPreferences = useSelector(
    (state: any) => state?.userChoicesReducer?.checkHHRSToggleValueCustomerPreferences
  );
  const HHSRSRepairEnabledToggle = useSelector(
    (state: any) => state?.userChoicesReducer?.checkHHRSRepairEnabledToggleValue
  );  
  const priorityCodeValue = useSelector(
    (state: any) => state.userChoicesReducer?.repairPriority
  ); 
  let [latestProirity, setLatestPriority] = useState<string>(priorityCodeValue);
  const dmcInspectionSorCodes = useSelector(
    (state: any) => state?.userChoicesReducer?.dmcInspectionSorCodeValues
  );

  const vulnerabilityExcludedSorcodes = useSelector(
    (state: any) => state?.userChoicesReducer?.vulnerabilityExcludedSorcodeValues
  );
  const userChosenDmcLocation = useSelector(
    (state: any) => state.userChoicesReducer.userChosenDmcLocation
  );
  const WOCreationTimeoutSeconds = useSelector((state: any) => state?.userChoicesReducer?.woCreationTimeoutSeconds);
  const WOCreationPollingDelaySeconds = useSelector((state: any) => state?.userChoicesReducer?.woCreationPollingDelaySeconds);
  const skipRespCheckForEMA = useSelector(
    (state: any) => state?.userChoicesReducer?.skipResponsibilityCheckForEMA
  );

  const DmcCheck = useSelector(
    (state: any) => state.userChoicesReducer.ExistingDMC
  );
  const dmcRiskRating = useSelector(
    (state: any) => state.userChoicesReducer?.dmcRiskRating
  );
  var isDMCWoCreated = false;
  const pollAbortRef = useRef<(() => void) | null>(null);
  const sleep = (ms: number) => new Promise<void>(r => setTimeout(r, ms));
  type PollOpts = {
    workOrderId: string;
    timeoutMs: number;
    delayMs: number;
    immediateFirstAttempt?: boolean;
  };

  type PollResult = { jobNo: string; attempts: number };
  type PollHandle = { promise: Promise<PollResult>; abort: () => void };

  const useLocationID = () => {
    const locationIDMapping: { [key: string]: string } = {
      '3': 'Bathroom',
      '4': 'Bedroom',
      '9': 'Kitchen',
      '15': 'Multiple Rooms',
      '31': 'Other room in your home',
    };

    const reverseMapping = Object.fromEntries(
      Object.entries(locationIDMapping).map(([key, value]) => [value, key])
    );

    return reverseMapping[userChosenDmcLocation] || null;
  };

  // locationID will be used to map the DMC location to the correct ID
  let locationID = useLocationID();

  useEffect(() => {
    if (blockErrorCode === "E36") {
      dispatch(isContinueButtonDisabled(true));
    } else {
      dispatch(isContinueButtonDisabled(false));
    }
  }, [blockErrorCode])

  useEffect(() => {
    if (dmcRiskRating === CasePriority.Low) {
      setShowDMLPreferenceQuestion(true);
    } else {
      setShowDMLPreferenceQuestion(false);
    }
  }, [dmcRiskRating]);

  const getVandalismDisplayText = (): string => {
    if (userChosenVandalismQuestionVal === "Yes") {
      if (userChosenVandalismAdditionalInformationBackButton?.trim()) {
        return `Yes , ${userChosenVandalismAdditionalInformationBackButton}`;
      } else {
        return "Yes";
      }
    } else if (userChosenVandalismQuestionVal === "No") {
      return "No";
    }
    return "";
  };

  const callCaseAssesmentApiData = async () => {
    try {
      const responseData = await api.getQuestionnaireMasterData()
      const keyValuePairs = responseData[0]?.namespace?.keyValues;
      for (const data of Object.entries(keyValuePairs)) {
        const [, value] = data;
        if (value && (value as any).id === '47') {
          // storing DMC questions in state and redux
          setDmcQuestions(value)
          setIsLoading(false)
        }
      }

    } catch (e) {
      setIsLoading(false);
      console.log(e)
    }
  }

  useEffect(() => {
    // Calling case assessment API if DMC have data
    if (dmcAnswersFromReducer && Object.keys(dmcAnswersFromReducer).length > 0 || userchosenDMC == "Yes") {
      callCaseAssesmentApiData();
      renderDMCData();
    }
    callPostRepairApi();
    const parsedData = Object.entries(savedAnswerKeys).reduce(
      (prev: any, curr: any) => {
        let mainData: any = {};
        const combinedData = Object.entries(curr[1]);
        combinedData.forEach(([key, value]: any) => {
          if (savedResponses[value] || key === "urlPath") {
            mainData = {
              ...mainData,
              [curr[1]["urlPath"]]: {
                ...mainData[curr[1]["urlPath"]],
                [key]:
                  key === "urlPath"
                    ? value
                    : {
                      key: value,
                      value: savedResponses[value],
                    },
              },
            };
          }
        });
        return {
          ...prev,
          ...mainData,
        };
      },
      {}
    );
    dispatch(updatePrevConfirmedState(parsedData));
  }, []);

  const callPostRepairApi = async () => {
   
    setDisabled(true);
    const advancedPayload = {
      priority: workOrderObject?.priority,
      sor: userChosenSOR,
      isPotentialDuplicate: userChosenDuplicateQuestion?.split("&")[2]
        ? true
        : userChosenDuplicateQuestion === t("duplicateNoneofTheAbove")
          ? true
          : false,
      isVulnerable: workOrderObject?.isEmergency
        ? false
        : userChosenVulnerabilityQuestion === "Yes"
          ? true
          : false,
      channel: "CustomerSelfService",
    };
    try {
      setBlockLoading(true);
      if (checkEnhancedEligibility) {
        const enhancedApiResponse = await api.postEnhancedRepairEligibility(
          advancedPayload
        );
        setBlockMsg(enhancedApiResponse?.isEligible);
        setBlockErrorCode(enhancedApiResponse?.errorCode);
        if (enhancedApiResponse?.isEligible === false) {
          setDisabled(true);
        } else {
          setDisabled(false);
        }
      } else {
        setDisabled(false);
      }
      setBlockLoading(false);
    } catch (e) {
      console.error(e);
      dispatch(showFooter(true));
      dispatch(userChosenVulnerabilityAdditionalInformation(""));
      props.history.push({
        pathname: '/repairJourneyErrorPage',
        state: { message: 'repair_Journey_Error_Message1' }
      });
    }
  };

  const exitButtonHandler = () => {
    dispatch(clearMediaFiles([]));
    dispatch(userChosenPropertyId(""));
    dispatch(userChosenPropertyType(""));
    dispatch(userChosenPropertyAddress(""));
    dispatch(userChosenRepairLocationId(0));
    dispatch(userChosenRepairLocation(""));
    dispatch(userChosenHighLevelDescription(""));
    dispatch(userChosenSupplementaryQuestions(""));
    dispatch(userChosenAdditionalDescription(""));
    dispatch(userChosenVandalismQuestion("No"));
    dispatch(userChosenVandalismAdditionalInformation(""));
    dispatch(userChosenCovidQuestion(""));
    dispatch(userChosenContactDetails(""));
    dispatch(userChosenSTATUS(""));
    dispatch(userChosenEligibilityErrorCode(""));
    dispatch(userChosenContactPhone(""));
    dispatch(userChosenContactName(""));
    dispatch(userChosenRelationDetails(""));
    dispatch(workOrderRepairObject(null));
    dispatch(dmcWorkOrderRepairObject(null));
    dispatch(calendarPageIndex(0));
    dispatch(originalRepairAppointmentWillNotBeCreated(false));
    dispatch(dmcRepairAppointmentWillNotBeCreated(false));
    dispatch(userChosenResumeRepair(false));
    dispatch(loadDuplicateRepairPage(false));
    dispatch(userCreatedNewRepair(null));
    dispatch(userGetRepairData(""));
    dispatch(saveEmailCopyRadioValue(""));
    props.history.push("/customer360View");
  };

  const saveDraftAndExit = () => {
    dispatch(saveEmailCopyRadioValue(""));
    props.history.replace("/customer360View");
  };
  const backButtonHandler = () => {
    props.history.push("/customerdetails");
  };

  //create method to check if DMC eligible and return True/false
  const isDMCEligible = () => {
    if (selectedproperty === "Property" && (!eligibilityResponseObject?.statuses?.isInDefects
      || (eligibilityResponseObject?.statuses?.isInDefects
        && workOrderObject?.assessmentInformation?.outcome?.adjustedRiskRating === CasePriority.High))
      && isDMCEnabledtoggleValue && workOrderObject?.isCausingDampAndMould
      && !dmcInspectionSorCodes?.includes(userChosenSOR)) {
      return true;
    } else {
      return false;
    }
  }

  function setParamsForDMCCreateWO(dmcWorkOrderObject: any) {
    dmcWorkOrderObject.id = null;
    dmcWorkOrderObject.isDraft = true;
    dmcWorkOrderObject.isOutOfHours = dmcoriginalWOPriorityResponse?.isWorkingHour === 'Y' ? false : true;
    dmcWorkOrderObject.isEMA = dmcWOContractorResponse?.[0]?.statuses?.isEMA;
    dmcWorkOrderObject.isSupplementary = false;
    dmcWorkOrderObject.isVandalism = false;
    dmcWorkOrderObject.isSubmitted = true;
    dmcWorkOrderObject.isCausingDampAndMould = null;
    dmcWorkOrderObject.worksOrderIdentifier = "";
    dmcWorkOrderObject.jobNo = "";
    dmcWorkOrderObject.contractor = dmcWOContractorResponse?.[0]?.contractorSites?.[0];
    dmcWorkOrderObject.contractorName = dmcWOContractorResponse?.[0]?.name;
    dmcWorkOrderObject.contractorPhoneNumber = dmcWOContractorResponse?.[0]?.contacts?.[0].addresses?.digitalAddresses?.[0]?.telecomsAddresses?.[0]?.number;
    dmcWorkOrderObject.originalWorkOrderIdentifier = null;
    dmcWorkOrderObject.caseIdentifier = "";
    dmcWorkOrderObject.repairLocationId = locationID;
    dmcWorkOrderObject.trade = "";
    dmcWorkOrderObject.repairCause = "General Wear and Tear";
    dmcWorkOrderObject.repairCauseId = RepairCauseId[workOrderObject.repairCause as keyof typeof RepairCauseId];
    dmcWorkOrderObject.sorCode = t('Investigate_DM_SorCode');
    dmcWorkOrderObject.repairReason = "Inspect Damp and Mould";
    dmcWorkOrderObject.description = 'Inspect Damp and Mould';
    dmcWorkOrderObject.additionalInformation = "";
    //to do remove mocking priority after testing
    dmcWorkOrderObject.priority = shouldApplyCustomerPreferencesForHHSRS() ? priorityCodeValue : dmcoriginalWOPriorityResponse?.repairPriority
    dmcWorkOrderObject.associatedWorkOrdersIdentifier = workOrderObject.id;
    dmcWorkOrderObject.associatedWorkOrdersJobNumber = "";
    dmcWorkOrderObject.associatedWorkOrdersType = "DampAndMould";
    dmcWorkOrderObject.assessmentInformation = workOrderObject.assessmentInformation;
    dmcWorkOrderObject.crimeReferenceNumber = null
    dmcWorkOrderObject.IsRaisedAsTriage = false;
    dmcWorkOrderObject.isEmergency = dmcoriginalWOPriorityResponse?.repairPriority === RepairPriorityCode.DampAndMouldEmergency;
    dmcWorkOrderObject.isPotentialDuplicate = false;
    dmcWorkOrderObject.isVulnerable = false;
    dmcWorkOrderObject.VulnerableResponseText = null;
    dmcWorkOrderObject.workProgramme = "RESP"
  }

  const dmcAggregator = async () => {
    const dmcWorkOrderObject = { ...workOrderObject };
    setParamsForDMCCreateWO(dmcWorkOrderObject);
    const _worksOrderRequest = new WorksOrderRequest(dmcWorkOrderObject);
    const woRequestParameters =
      _worksOrderRequest.updateWorkOrderParameter(dmcWorkOrderObject);
    try {
      const apiResponse = await api.createWorkOrderRepair({
        ...woRequestParameters,
      });

      if (apiResponse?.location.length > 0) {
        const workorderLocation = apiResponse?.location.split("/");
        dmcWorkOrderObject.id = workorderLocation[4];
        dmcWorkOrderObject.worksOrderIdentifier = workorderLocation[4];
      }
    }
    catch (e) {
      console.error(e);
      props.history.push("/repairJourneyErrorPage");
    }

    if (isNullOrUndefined(dmcWorkOrderObject?.id)) {
      patchOriginalWorkOrder(false);
      return;
    }

    const handle = pollJobNumber({
      workOrderId: dmcWorkOrderObject?.id,
      timeoutMs: WOCreationTimeoutSeconds * 1000,
      delayMs: WOCreationPollingDelaySeconds * 1000,
      immediateFirstAttempt: false,
    });

    try { pollAbortRef.current?.(); } catch { }
    pollAbortRef.current = handle.abort;

    const res = await handle.promise;

    pollAbortRef.current = null;
    if (res.jobNo) {
      dmcWorkOrderObject.jobNo = res.jobNo;
      dispatch(dmcWorkOrderRepairObject(dmcWorkOrderObject));
      handleEmailNotes(res.jobNo)
      patchOriginalWorkOrder(true, dmcWorkOrderObject.id, res.jobNo);
    } else {
      console.log("DMC Job Number not created after all the attempts");
      dispatch(dmcWorkOrderRepairObject(dmcWorkOrderObject));
      patchOriginalWorkOrder(true, dmcWorkOrderObject.id, "");
    }
  }

  const pollJobNumber = (opts: PollOpts): PollHandle => {
    const { workOrderId, timeoutMs, delayMs, immediateFirstAttempt } = opts;
    let aborted = false;
    let attempts = 0;

    const abort = () => { aborted = true; };

    const promise = (async (): Promise<PollResult> => {
      const start = Date.now();
      if (!immediateFirstAttempt) await sleep(delayMs);

      while (!aborted && (Date.now() - start) < timeoutMs) {
        attempts++;
        try {
          const repair = await api.getRepair(workOrderId);
          const jobNo = (repair?.jobNo || "").trim();
          if (jobNo) return { jobNo, attempts };
        } catch { }
        const remaining = timeoutMs - (Date.now() - start);
        if (remaining <= 0) break;
        await sleep(Math.min(delayMs, remaining));
      }
      return { jobNo: "", attempts };
    })();

    return { promise, abort };
  };

  function patchOriginalWorkOrder(isMultiWorkOrder: boolean = false, workOrderid: string = "", jobNumber: string = "") {
    if (
      !isNullOrUndefined(userChosenDuplicateQuestion)
      || userChosenSOR === "NA" || (!isNullOrUndefined(vulnerabilityAdditionalInformation)
        && (!vulnerabilityExcludedSorcodes?.includes(selectedSorCodeValue)))
    ) {
      isTriageCase = true;
    } else {
      isTriageCase = false;
    }
    let isCatalystTriageTier2Ema = false;
    let siteIdentifier = [];
    if (determinedcontractordetails) {
      siteIdentifier = determinedcontractordetails?.contractorSites ?? determinedcontractordetails?.contractorSites[0];
      isCatalystTriageTier2Ema = ((siteIdentifier[0] === CatalistTriageContractorType.CATALYST_TRIAGE_TIER2) || (siteIdentifier[0] === CatalistTriageContractorType.CATALYST_TRIAGE_EMA));
    }
    if (isTriageCase || isCatalystDefectTriageCase || isCatalystTriageTier2Ema) {
      dispatch(userChosenPropertyId(""));
      dispatch(comingFromRepairJourneySuccess(true))
      submitForm(siteIdentifier[0], isMultiWorkOrder, workOrderid, jobNumber);
    } else {
      dispatch(comingFromRepairJourneySuccess(true))
      submitForm(siteIdentifier[0], isMultiWorkOrder, workOrderid, jobNumber);
    }
  };

  const callPageHandler = () => {
    setLoaderPage(true)
    setDisabled(true);
    if (isDMCEligible() && DmcCheck && !isUndefinedNullOrEmpty(dmcWOContractorResponse)) {
      isDMCWoCreated = true;
      dmcAggregator();
    }
    else {
      patchOriginalWorkOrder(false);
    }
  };

  const redirect = (url: string) => {
    dispatch(isEditState(true));
    props.history.push(url);
  };

  const renderData = (item: any, index: any) => {
    saveIndex = index;
    return (
      <>
        <div className={`${index % 2 === 0 ? 'confirm-bg-grey' : ''} row `} >
          <div className="col-11"
            id={"confirmation-tr1" + item[0]}
          >
            <h6 className="confirm-span1 padding-1"
              id={"confirmation-tr1-td1" + item[0]}>

              {/* @ts-ignore */}
              {questions?.translation[item[0]] === t("Customer_Details")
                ? t("Customer_Details_Text_Two")
                : //  @ts-ignore
                questions?.translation[item[0]]}

              {item[0] === "ConfirmedDampMould" && selectedproperty === "Property" && DmcCheck && !dmcInspectionSorCodes?.includes(selectedSorCodeValue) ? (
                t("DMC_Question")) :
                ""}
            </h6>

            <p className="confirm-span2 padding-1"
              id={"confirmation-tr1-td2" + item[0]}
            >
              <div
                id={"confirmation-tr1-div2" + item[0]}
              >
                {item[0] === "VandalismQuestion" ? (
                  getVandalismDisplayText()
                ) : (

                  <>
                    {" "}
                    {!savedResponses[item[1]?.reduxKeyQs]
                      ? savedResponses[item[1]?.reduxKey].split("@")[0]
                      : ""}
                    {savedResponses[item[1]?.reduxKeyQs]
                      ? savedResponses[item[1]?.reduxKeys]
                      : ""}
                    {"\n"}
                    {savedResponses[item[1]?.reduxKeyQs]}
                    <br></br>
                    {savedResponses[item[1]?.reduxKeyselect]}
                  </>)}
              </div>
            </p>
          </div>
          <div className="col-1"
            id={"confirmation-tr1-td3" + item[0]}
          >
            <span
              id={"confirmation-tr1-div3" + item[0]}
              className="text-center"
            >
              {" "}
              <i
                data-testid="confirmation-icon"
                id={"confirmation-tr1-icon" + item[0]}
                className="fas fa-edit text-teal"
                onClick={() => {
                  redirect(`/${item[1]?.urlPath}`);
                }}
              ></i>
            </span>
          </div>
        </div>
      </>
    );
  };

  const vandalismConfigValue = useSelector(
    (state: any) => state?.addresses?.vandalismtoggleValue
  );
  const userChosenUPRN = useSelector(
    (state: any) => state.userChoicesReducer.userChosenUPRN
  );
  const userChosenSOR = useSelector(
    (state: any) => state.userChoicesReducer.userChosenSOR
  );

  const userMaintResp = useSelector((state: any) => state.addresses.maintresp);
  const userRepairResp = useSelector(
    (state: any) => state.addresses.repairresp
  );
  const userVandalismChoice = useSelector(
    (state: any) => state.userChoicesReducer.userChosenVandalismQuestion
  );

  const userChosenDuplicateQuestion = useSelector(
    (state: any) => state?.userChoicesReducer?.userChosenDuplicateQuestion
  );
  const selectedSorCodeValue = useSelector((state: any) => state?.userChoicesReducer?.userChosenSOR);
  const userchosenDMC = useSelector((state: any) => state.userChoicesReducer?.DMCChecksavedAnswer);
 //to do remove after testing - mocked for testing only
  

  const shouldApplyCustomerPreferencesForHHSRS = (): boolean => {   
   
    return (
      HHSRSToggleForCustomerPreferences && HHSRSRepairEnabledToggle && isHHSRSAssessmentCompleted &&
      !isUndefinedNullOrEmpty(
        selectedRepairReasonObject[0].hazardType &&
        isHHSRSAssessmentCompleted &&
        (priorityCodeValue === RepairPriorityCode.AWAABSLAWEMERGENCY ||
          priorityCodeValue === RepairPriorityCode.AWAABSLAWSIGNIFICANT ||
          priorityCodeValue === RepairPriorityCode.AWAABSLAWLOW)
      )
    );
  };

  const shouldApplyCustomerPreferencesForDMC = (): boolean => {
    return (
      ValueCustomerPreferences &&
      (dmcInspectionSorCodes?.includes(workOrderObject?.sorCode) || userchosenDMC === "Yes")
    );
  };

  const shouldApplyCustomerPreferences = (): boolean => {
    return shouldApplyCustomerPreferencesForDMC() || shouldApplyCustomerPreferencesForHHSRS();
  };

  const selectedproperty = useSelector(
    (state: any) => state?.userChoicesReducer?.userChosenPropertyType
  );

  const userChosenHighLevelDescriptionVal = useSelector(
    (state: any) => state.userChoicesReducer.userChosenHighLevelDescription
  );

  let isTriageCase = false;

  const isCatalystDefectTriageCase = isCatalyst && eligibilityResponseObject?.statuses?.isInDefects === true

  const userChosenVulnerabilityQuestion = useSelector(
    (state: any) => state.userChoicesReducer.userChosenVulnerabilityQuestion
  );

  const vulnerabilityAdditionalInformation = useSelector(
    (state: any) =>
      state.userChoicesReducer.userChosenVulnerabilityAdditionalInformation
  );

  const userChosenVandalismAdditionalInformationBackButton = useSelector(
    (state: any) =>
      state.userChoicesReducer.userChosenVandalismAdditionalInformation
  );
  const customerDetails = useSelector(
    (state: any) => state.addresses.saveCustomerDetails
  );
  const isVandalismEligible = eligibilityResponseObject?.statuses?.isInDefects === true && selectedproperty !== AssetType.Property && vandalismConfigValue === true;
  const workOrderUpdate = async (isMultiWorkOrder: boolean, workOrderId: string, jobnumber: string) => {
    try {
      const isEMA = determinedcontractordetails?.statuses?.isEMA;

      workOrderObject.isDraft = true;
      if (isEMA) {
        workOrderObject.isEMA = true;
      }

      const siteIdentifier = determinedcontractordetails?.contractorSites
        ? determinedcontractordetails?.contractorSites?.[0]
        : null;
      workOrderObject.contractor = siteIdentifier;

      userChosenSupplementaryQuestionsVal === "Yes"
        ? (workOrderObject.isSupplementary = true)
        : userChosenSupplementaryQuestionsVal === "No"
          ? (workOrderObject.isSupplementary = false)
          : (workOrderObject.isSupplementary = null);

      userChosenVandalismQuestionVal === "Yes" && isVandalismEligible ? (workOrderObject.isVandalism = true)
        : userChosenVandalismQuestionVal === "No" && isVandalismEligible ? (workOrderObject.isVandalism = false)
          : (workOrderObject.isVandalism = null);

      userChosenCovidQuestionVal === "Yes" && covidConfigValue
        ? (workOrderObject.isCovidSelfIsolated = true)
        : userChosenCovidQuestionVal === "No" && covidConfigValue
          ? (workOrderObject.isCovidSelfIsolated = false)
          : (workOrderObject.isCovidSelfIsolated = null);

      userChosenDuplicateQuestion === ""
        ? (workOrderObject.isPotentialDuplicate = false)
        : (workOrderObject.isPotentialDuplicate = true);
      userChosenVulnerabilityQuestion !== "" &&
        userChosenVulnerabilityQuestion !== null &&
        userChosenVulnerabilityQuestion === "Yes"
        ? (workOrderObject.isVulnerable = true)
        : userChosenVulnerabilityQuestion === "No"
          ? (workOrderObject.isVulnerable = false)
          : (workOrderObject.isVulnerable = null);
      vulnerabilityAdditionalInformation !== ""
        ? (workOrderObject.VulnerableResponseText =
          vulnerabilityAdditionalInformation)
        : (workOrderObject.VulnerableResponseText = null);

      userChosenSOR !== ""
        ? (workOrderObject.sorCode = userChosenSOR)
        : (workOrderObject.sorCode = "NA");

      if (userVandalismChoice === "Yes" && isVandalismEligible) {
        workOrderObject.crimeReferenceNumber =
          userChosenVandalismAdditionalInformationBackButton;
        workOrderObject.repairCause = "Vandalism or Damage";
        workOrderObject.repairCauseId =
          RepairCauseId[
          workOrderObject.repairCause as keyof typeof RepairCauseId
          ];
      }
      // Update this check to based on HHSRS assesment complition result  
      else if (shouldApplyCustomerPreferencesForHHSRS()) {
          workOrderObject.crimeReferenceNumber = "";
          workOrderObject.repairCauseId = Helper.HHSRSRepairCauseId;
          workOrderObject.repairCause = Helper.RepairCauseLabels[Helper.HHSRSRepairCauseId];  
              
          }
       else {
        workOrderObject.crimeReferenceNumber = "";
        workOrderObject.repairCause = "General Wear and Tear";
        workOrderObject.repairCauseId =
          RepairCauseId[
          workOrderObject.repairCause as keyof typeof RepairCauseId
          ];
      }
      workOrderObject.isSubmitted = true;
      workOrderObject.priority = latestProirity;
      if (!isDMCEnabledtoggleValue) {
        workOrderObject.isCausingDampAndMould = null;
        workOrderObject.assessmentInformation = undefined;
      }
      //update associatedWorkOrders for multi work order   
      if (isMultiWorkOrder && workOrderId) {
        workOrderObject.associatedWorkOrdersIdentifier = workOrderId;
        workOrderObject.associatedWorkOrdersType = "DampAndMould";
        workOrderObject.associatedWorkOrdersJobNumber = !isNullOrUndefined(jobnumber) ? jobnumber : "";
      }
       dispatch(saveHHSRSAssessmentCompleted(false)); 
      const _worksOrderRequest = new WorksOrderRequest(workOrderObject);
      const woRequestParameters =
        _worksOrderRequest.updateWorkOrderParameter(workOrderObject);
      const apiResponse = await api.updateWorkOrderRepair(
        woRequestParameters,
        workOrderObject.id,
        "eTag"
      );
      dispatch(workOrderRepairObject(workOrderObject));
    } catch (e) {
      console.error(e);
      dispatch(showFooter(true));
      dispatch(userChosenVulnerabilityAdditionalInformation(""));
      props.history.push({
        pathname: '/repairJourneyErrorPage',
        state: { message: 'repair_Journey_Error_Message1' }
      });
    } finally {
      setIsLoading(false);
    }
  };

  const getNotesCreationPayload = (text: string) => {
    const notesCreationPayload = {
      noteTypeId: t("Other_note_value"),
      text: text,
    };
    return notesCreationPayload;
  };

  function AddingNotes(getNotesCreationPayload: () => { noteTypeId: string; text: string; }, jobNumber: string) {
    const createdNotesPayload = getNotesCreationPayload();
    const [serialNumber, sequenceNumber] = jobNumber.split("/");
    return api.postNoteForWorkorder(
      serialNumber,
      sequenceNumber,
      createdNotesPayload
    );
  }

  const addPreAssessmentNotes = async (jobNumber: string) => {
    if (selectedRepairReasonObject?.[0]?.isPreAssessmentRequired !== true) {
      return;
    }

    const noteText = await buildPreAssessmentNoteText(
      hazardResponses,
      assessmentOutcome,
      selectedRepairReasonObject,
      isHHSRSAssessmentCompleted,
    );
    if (!noteText) {
      return;
    }

    AddingNotes(() => getNotesCreationPayload(noteText), jobNumber);
  };

  const shouldSkipDmcRepairAppointment = (dmcJobNumber: string) => {
    if (!isDMCWoCreated) {
      return false;
    }

    return isNullOrUndefined(dmcJobNumber) ||
      dmcoriginalWOPriorityResponse?.repairPriority === RepairPriorityCode.DampAndMouldEmergency ||
      dmcWOContractorResponse[0]?.statuses?.isEMA ||
      !dmcWOContractorResponse[0]?.statuses?.isIntegrated ||
      dmcWOContractorResponse[0]?.statuses?.isBuilder;
  };

  const submitForm = async (siteCode: string, isMultiWorkOrder: boolean, dmcWorkOrderId: string, dmcJobNumber: string) => {
     dispatch(saveEmailCopyRadioValue(""));
     dispatch(saveHHSRSAssessmentCompleted(false));
    const contractorSiteOnHoldCase = determinedcontractordetails?.contractorSites?.[0] === CatalistTriageContractorType.CONTRACTORSITE_ON_HOLD;
    const isTriageCase = userChosenDuplicateQuestion != "" ||
      userChosenSOR === "NA" ||
      (vulnerabilityAdditionalInformation !== "" && !vulnerabilityExcludedSorcodes?.includes(selectedSorCodeValue))
    let jobWillNotBeCreated = isTriageCase || isCatalystDefectTriageCase
      || siteCode === CatalistTriageContractorType.CATALYST_TRIAGE_TIER2
      || siteCode === CatalistTriageContractorType.CATALYST_TRIAGE_EMA
      || siteCode === EMAContractorType.UNKNOWN_EMA_TRIAGE
      || siteCode === EMAContractorType.EMA_UNKNOWN_CONTACTDETAILS_TRIAGE;

    if (dmcInspectionSorCodes?.includes(selectedSorCodeValue) && isCatalystDefectTriageCase
      && workOrderObject?.assessmentInformation?.outcome?.adjustedRiskRating === CasePriority.High) {
      jobWillNotBeCreated = false;
    }
   const isHHSRSEmergency =
      isHHSRSAssessmentCompleted &&
      workOrderObject?.priority === RepairPriorityCode.AWAABSLAWEMERGENCY;

    const isOriginalRepairAppointmentWillNotBeCreated =
      contractorSiteOnHoldCase ||
      workOrderObject.isEmergency || isHHSRSEmergency ||
      determinedcontractordetails?.statuses?.isEMA ||
      !determinedcontractordetails?.statuses?.isIntegrated ||
      determinedcontractordetails?.statuses?.isBuilder;
    const isDmcRepairAppointmentWillNotBeCreated = shouldSkipDmcRepairAppointment(dmcJobNumber);
    dispatch(originalRepairAppointmentWillNotBeCreated(isOriginalRepairAppointmentWillNotBeCreated));
    dispatch(dmcRepairAppointmentWillNotBeCreated(isDmcRepairAppointmentWillNotBeCreated));
    dispatch(isOnHoldRepair(contractorSiteOnHoldCase));
    workOrderUpdate(isMultiWorkOrder, dmcWorkOrderId, dmcJobNumber);
    const noOfHits = process.env.REACT_APP_API_HITS;
    const timeoutValue = process.env.REACT_APP_API_TIMEOUT;
    const noOfHitsValue = Number(noOfHits);
    const noOfTimeoutValue = Number(timeoutValue);

    let i = 0,
      jobNumber = "",
      workOrderId = workOrderObject?.id;
    let riskRating: string | undefined;
    let isInDefectValue = false;
    let caseIdentifiers = "";
    if (!jobWillNotBeCreated) {
      dispatch(setTriageRepair(false));
      let interval = setInterval(async () => {
        if (i < noOfHitsValue) {
          i++;
          try {
            if (isNullOrUndefined(jobNumber)) {
              const repair = await api.getRepair(workOrderId);
              caseIdentifiers = repair?.caseIdentifier
              dispatch(userChosenPropertyType(repair.area));
              dispatch(userGetRepairData(repair));
              jobNumber = repair?.jobNo;
              riskRating = repair?.assessmentInformation?.outcome?.adjustedRiskRating?.toUpperCase();
              isInDefectValue = repair?.isInDefect;
            }

            if (!isNullOrUndefined(jobNumber)) {
              if (dmcInspectionSorCodes?.includes(selectedSorCodeValue)) {
                handleEmailNotes(jobNumber)
              }

              clearInterval(interval);
              dispatch(setTriageRepair(false));
              workOrderObject.jobNo = jobNumber;
              dispatch(workOrderRepairObject(workOrderObject));
              await addPreAssessmentNotes(jobNumber);

              if (isOriginalRepairAppointmentWillNotBeCreated) {
                if (isInDefectValue && shouldApplyCustomerPreferences() && (riskRating === CasePriority.Low || riskRating === CasePriority.Medium)) {
                  AddingNotes(() => getNotesCreationPayload(t("DMC_Note_14_days_SLA")), jobNumber);
                }
                dispatch(userGetRepairData(""));
                dispatch(userChosenPropertyType(selectedproperty));
                dispatch(setWorkOrderApiFailureMessage(false));
                if (isDMCWoCreated) {
                  if (isDmcRepairAppointmentWillNotBeCreated) {
                    props.history.push("/repairFinalDetails");
                  }
                  else {
                    dispatch(calendarPageIndex(1));
                    props.history.push("/appointmentscheduler");
                  }
                } else if (workOrderObject?.isCausingDampAndMould
                  && eligibilityResponseObject?.statuses?.isInDefects) {
                  props.history.push("/repairFinalDetails");
                }
                else {
                  props.history.push("/customer360View");
                }
              } else {
                dispatch({ type: CASE_IDENTIFIER, payload: caseIdentifiers });
                dispatch(setWorkOrderApiFailureMessage(false));
                props.history.push("/appointmentscheduler");
              }
            }
          }
          catch (e) {
            console.error(e);
            clearInterval(interval);
            if (isDMCWoCreated) {
              if (isDmcRepairAppointmentWillNotBeCreated) {
                props.history.push("/repairFinalDetails");
              }
              else {
                dispatch(calendarPageIndex(1));
                dispatch(originalRepairAppointmentWillNotBeCreated(true));
                props.history.push("/appointmentscheduler");
              }
            } else if (workOrderObject?.isCausingDampAndMould
              && eligibilityResponseObject?.statuses?.isInDefects) {
              props.history.push("/repairFinalDetails");
            }
            else {
              showWorkorderErrorPage(interval);
            }
          }
        }
        else {
          console.log("Job No not created after all the attempts");
          clearInterval(interval);
          if (isDMCWoCreated) {
            if (isDmcRepairAppointmentWillNotBeCreated) {
              props.history.push("/repairFinalDetails");
            }
            else {
              dispatch(calendarPageIndex(1));
              dispatch(originalRepairAppointmentWillNotBeCreated(true));
              props.history.push("/appointmentscheduler");
            }
          } else if (workOrderObject?.isCausingDampAndMould
            && eligibilityResponseObject?.statuses?.isInDefects) {
            props.history.push("/repairFinalDetails");
          }
          else {
            showWorkorderErrorPage(interval);
          }
        }
      }, noOfTimeoutValue);
      return () => clearInterval(interval);
    }
    else {
      dispatch(setTriageRepair(true));
      dispatch(saveAlternateEmailValue(""));     
      dispatch(isSendCopyDampMouldReport(false))
      if (isDMCWoCreated) {
        if (isDmcRepairAppointmentWillNotBeCreated) {
          props.history.push("/repairFinalDetails");
        }
        else {
          dispatch(calendarPageIndex(1));
          props.history.push("/appointmentscheduler");
        }
      } else if (workOrderObject?.isCausingDampAndMould
        && eligibilityResponseObject?.statuses?.isInDefects) {
        props.history.push("/repairFinalDetails");
      }
      else {       
        props.history.push("/customer360View");
      }
    }
  };

  const showWorkorderErrorPage = async (interval: any) => {
    clearInterval(interval);
    dispatch(showFooter(true));
    dispatch(userGetRepairData(""));
    dispatch(userChosenPropertyType(""));
    dispatch(saveAlternateEmailValue(""));
    dispatch(saveEmailCopyRadioValue(""));
    dispatch(isSendCopyDampMouldReport(false))
    dispatch(userChosenVulnerabilityAdditionalInformation(""));
    if (isDMCWoCreated) {
      props.history.push("/repairFinalDetails");
    }
    else {
      props.history.push("/workOrderErrorPage");
    }
  }

  const renderDMCData = () => {
    const questionData = dmcQuestionsFromReducer && Object.keys(dmcQuestionsFromReducer).length > 0 ? dmcQuestionsFromReducer : dmcQuestions;
    return questionData?.additionalInfo?.map((question: any, index: number) => {
      const matchingAnswer = dmcAnswersFromReducer[question?.questionId];
      return (
        <div className={`${index % 2 === 0 ? 'confirm-bg-grey' : ''} row`} key={question?.questionId}>
          <div className="col-11">
            <h6 className="confirm-span1 padding-1">
              {question?.label}
            </h6>
            <p className="confirm-span2 padding-1">
              {Array.isArray(matchingAnswer)
                ? matchingAnswer.map((answerId: any) =>
                  question?.options?.find((option: any) => option?.id === answerId)?.value
                ).join(", ")
                : question?.options?.find((option: any) => option?.id === matchingAnswer)?.value}
            </p>
          </div>
          <div className="col-1">
            <span className="text-center">
              <i
                data-testid="confirmation-icon"
                className="fas fa-edit text-teal"
                onClick={() => {
                  redirect(`/DampAndMouldAssesment/${question?.pageGroupId}`);
                }} onKeyDown={() => {
                  redirect(`/DampAndMouldAssesment/${question?.pageGroupId}`);
                }}
              ></i>
            </span>
          </div>
        </div>
      );
    })
  };
  const handleEmailNotes = (jobNumber: any) => {
    if (shouldApplyCustomerPreferences()) {
      setTimeout(() => {
        if (alternateEmailValue) {
          AddingNotes(() => getNotesCreationPayload(`${t("notes_send")} ${alternateEmailValue}`), jobNumber);
        } else if (saveDampReport) {
          AddingNotes(() => getNotesCreationPayload(`${t("notes_send")} ${customerDetails?.addresses?.digitalAddresses[0]?.address}`), jobNumber);
        }
        else {
          AddingNotes(() => getNotesCreationPayload(`${t("notes_send_correspondence_address")}`), jobNumber);
        }
        dispatch(saveAlternateEmailValue(""));
        dispatch(saveEmailCopyRadioValue(""));
        dispatch(isSendCopyDampMouldReport(false))
      }, 1500);
    }
  }
  const displayDMCEmailReport = () => {   
  
    const isAlternateEmailPresent = alternateEmailValue;
    const isReportCopySelected =
      getEmailCopyValue === t("DMC_option_report_copy") ||
      getEmailCopyValue === t("HHSRS_Preference_DoNotHaveEmail");
    const reportCopyDisplay = shouldApplyCustomerPreferencesForHHSRS()
      ? t("HHSRS_Preference_DoNotHaveEmail")
      : t("DMC_option_report_copy");
    const defaultEmailDisplay = t("DMC_option_email") + customerDetails?.addresses?.digitalAddresses[0]?.address;
    let confirmationPreferenceHeader = t("Confirmation_page");
    if (shouldApplyCustomerPreferencesForHHSRS()) {
      confirmationPreferenceHeader = t("CPR088_HHRS_ConfirmationPage");
    }
    if (showDMLPreferenceQuestion) {
      confirmationPreferenceHeader = t("SummaryPage_DMC_Preference_Question_DML");
    }

    const emailDisplayWhenNoAlternate = isReportCopySelected ? reportCopyDisplay : defaultEmailDisplay;
    const emailDisplay = isAlternateEmailPresent
      ? t("DMC_option_email") + alternateEmailValue
      : emailDisplayWhenNoAlternate;

    return (
      <div className={`${saveIndex % 2 === 0 ? 'confirm-bg-grey' : ''} row`}>
        <div className="col-11">
          <h6 className="confirm-span1 padding-1">
            {confirmationPreferenceHeader}        </h6>
          <p className="confirm-span2 padding-1">
            {emailDisplay}</p>
        </div>
        <div className="col-1">
          <span className="text-center">
            <i
              data-testid="confirmation-icon"
              className="fas fa-edit text-teal"
              onClick={() => {
                redirect(`/customerdetails`);
              }} onKeyDown={() => {
                redirect(`/customerdetails`);
              }}
            ></i>
          </span>
        </div>
      </div>
    );
  }

  const getContactorAndRepairPriority = async (
    payload: {
      repairId: string;
      priorityCode: string;
      region: string;
      sorCode: string;
      repairTime: string;
      uprn: string;
      raisedDate: string;
      repairCauseId: number;
      maintenanceResponsibility: string;
      repairResponsibility: string;
      borough: string;
      isVandalism: boolean;
      isEmergency: boolean;
      description: string;
      isVulnerable: boolean;
      assessmentInformation: {
        outcome: {
          riskRating: string;
          adjustedRiskRating: string;
        };
        type: string;
      };
      isV14Upgradable: boolean;
    },
    isCatalystDefectTriageCase: boolean

  ) => {
    try {
      let contractorDetails: any = null;
      let assessmentTypeValue = '';
      let adjustedRiskRatingValue = '';
      let riskRatingValue = payload.assessmentInformation?.outcome?.riskRating;
      if (dmcInspectionSorCodes.includes(payload.sorCode)) {
        assessmentTypeValue = payload.assessmentInformation?.type;
        adjustedRiskRatingValue = payload.assessmentInformation?.outcome?.adjustedRiskRating;
        riskRatingValue = adjustedRiskRatingValue;
      }
      if (isCatalystDefectTriageCase) {
        contractorDetails = [
          {
            id: CatalistTriageContractorType.CATALYST_TRIAGE_DEFECT,
            name: "Catalyst Defect Triage",
            statuses: {
              isIntegrated: false,
              isBuilder: false,
              isSubContractor: false,
              isEMA: false,
              isActive: true,
            },
            contractorSites: ["CATALYST_TRIAGE_DEFECT"],
            emaType: "",
            contacts: [{}],
            _links: [],
            parentIdentifier: null,
          },
        ];
      }
      else {
        // Fetch contractor details from api
        contractorDetails = await api.getDeterminedContractor(
          payload.repairId,
          payload.priorityCode,
          payload.region,
          payload.sorCode,
          payload.repairTime,
          payload.uprn,
          payload.raisedDate,
          payload.repairCauseId,
          payload.maintenanceResponsibility,
          payload.repairResponsibility,
          payload.borough,
          payload.isVandalism,
          payload.assessmentInformation?.type ?? assessmentTypeValue,
          getRiskRating?.risk?.adjusted ?? adjustedRiskRatingValue,
          skipRespCheckForEMA
        );
      }
      if (!contractorDetails?.[0]) {
        throw new Error('No contractor details returned');
      }
      else if (contractorDetails?.[0].statuses?.isEMA && contractorDetails?.[0].statuses?.isActive && (contractorDetails?.[0].contacts == null || contractorDetails?.[0].contacts?.length < 1) && contractorDetails?.[0].id != EMAContractorType.UNKNOWN_EMA_TRIAGE) {
        contractorDetails = [
          {
            id: EMAContractorType.EMA_UNKNOWN_CONTACTDETAILS_TRIAGE,
            name: "EMA Unknown Contact Details Triage",
            statuses: {
              isIntegrated: false,
              isBuilder: false,
              isSubContractor: false,
              isEMA: true,
              isActive: true,
            },
            contractorSites: ["EMA_UNKNOWN_CONTACTDETAILS_TRIAGE"],
            emaType: "",
            contacts: [{}],
            _links: [],
            parentIdentifier: null,
          },
        ];
      }

      // Adding isANATypes for customer preferences
      let isAnaTypeValue = false;
      if (customerDetails?.preferences?.length > 0) {
        isAnaTypeValue = customerDetails?.preferences?.some((additionalNeedAlert: any) => additionalNeedAlert.preference.type === 'additionalNeeds');
      }
      let tenureCode = "";
      if (customerDetails?.tenanciesSummaries.length > 1) {
        const tenancySummary = customerDetails?.tenanciesSummaries?.filter(
          (tenancy: any) =>
            tenancy?.tenancySummary?.tenancyEndDate === null
        );
        tenureCode = tenancySummary[0]?.tenancySummary?.tenancyTenureCode;
      }
      else {
        tenureCode = customerDetails?.tenanciesSummaries[0]?.tenancySummary?.tenancyTenureCode;
      }
      // Fetch repair priority
      let repairPriority = await api.postRepairPriority({
        repairType: payload.sorCode,
        contractorIdentifier: contractorDetails?.[0].id,
        isEmergency: payload.isEmergency,
        isRecall: false,
        isEMA: contractorDetails?.[0].statuses.isEMA ? "Y" : "N",
        isVulnerable: payload.isVulnerable,
        description: payload.description,
        raisedDate: payload.raisedDate,
        isAnaType: isAnaTypeValue,
        channel: RepairChannel.CustomerSelfService,
        riskRating: getRiskRating?.risk?.adjusted ?? riskRatingValue,
        assessmentType: payload.assessmentInformation?.type,
        tenureCode: tenureCode,
        workProgramme: workOrderObject?.workProgramme || 'RESP',
        premisesType: workOrderObject?.premisesType || eligibilityResponseObject?.assetType,
        isV14Upgradable: payload.isV14Upgradable,
        hasSeasonalPriority: selectedRepairReasonObject?.[0]?.hasSeasonalPriority || false
      });     
      if (isDMCEligible()) {
        return {
          determinedContractorResp: contractorDetails,
          updatedRepairPriorityResp: repairPriority
        };
      } else if (shouldApplyCustomerPreferencesForHHSRS()) {
        //to do remove if condition mocking after testing , will undo this line after HHSRS priority
        latestProirity = priorityCodeValue;
        setLatestPriority(priorityCodeValue);
        dispatch(repairPriorityValue(priorityCodeValue));
      } else {
        latestProirity = repairPriority?.repairPriority;
        setLatestPriority(repairPriority?.repairPriority);
        dispatch(repairPriorityValue(repairPriority?.repairPriority));
      }

      return {
        determinedContractorResp: contractorDetails,
        updatedRepairPriorityResp: repairPriority
      };
    } catch (error) {
      console.error('Error in getContactorAndRepairPriority:', error);
      throw error;
    }
  };

  useEffect(() => {
    (async function () {
      // Disable the continue button and show loading state
      setDisabled(true);
      setIsLoading(true);
      if (
        !isNullOrUndefined(userChosenDuplicateQuestion) ||
        userChosenSOR === "NA" ||
        (!isNullOrUndefined(vulnerabilityAdditionalInformation) &&
          !vulnerabilityExcludedSorcodes?.includes(selectedSorCodeValue))
      ) {
        isTriageCase = true;
      } else {
        isTriageCase = false;
      }

      if (!isTriageCase || (isTriageCase && isDMCEligible())) {
        try {
          
          // Create payload for original work order
          const originalWoPayload = {
            repairId: workOrderObject?.id,
            priorityCode: workOrderObject?.priority,
            region: eligibilityResponseObject?.region,
            sorCode: userChosenSOR,
            repairTime: new Date().getHours().toString(),
            uprn: userChosenUPRN,
            raisedDate: moment(new Date()).format("YYYY-MM-DDTHH:mm:ss"),
            repairCauseId: isVandalismEligible && userVandalismChoice === "Yes" ? 4 : 1,
            maintenanceResponsibility: userMaintResp,
            repairResponsibility: userRepairResp,
            borough: boroughName || "",
            isVandalism: isVandalismEligible && userVandalismChoice === "Yes",
            isEmergency: workOrderObject?.isEmergency,
            description: userChosenHighLevelDescriptionVal,
            isVulnerable: userChosenVulnerabilityQuestion === "Yes",
            assessmentInformation: workOrderObject?.assessmentInformation,
            isV14Upgradable: selectedRepairReasonObject?.[0]?.isV14Upgradable ?? false
          };
          let commonContractorDeterminationResponse = null;
          if (isDMCEligible()) {
            const adjustedRiskRating = workOrderObject?.assessmentInformation?.outcome?.adjustedRiskRating;
            let dampMouldPriorityCode = originalWoPayload.priorityCode;

            if (adjustedRiskRating === CasePriority.High) {
              dampMouldPriorityCode = RepairPriorityCode.DampAndMouldEmergency;
            } else if (adjustedRiskRating === CasePriority.Medium) {
              dampMouldPriorityCode = RepairPriorityCode.DampAndMouldSignificant;
            } else if (adjustedRiskRating === CasePriority.Low) {
              dampMouldPriorityCode = RepairPriorityCode.DampAndMouldLowRisk;
            }

            const isHighCasePriority = adjustedRiskRating === CasePriority.High;
            // Create payload for damp/mould investigation WO
            const dampMouldWoPayload = {
              ...originalWoPayload,
              priorityCode: dampMouldPriorityCode,
              repairResponsibility: userRepairResp,
              isVandalism: false,
              sorCode: t('Investigate_DM_SorCode'),
              description: 'Inspect Damp and Mould',
              isEmergency: isHighCasePriority,
              isV14Upgradable: false
            };
            if (!isTriageCase && ((!eligibilityResponseObject?.statuses?.isInDefects
              || (eligibilityResponseObject?.statuses?.isInDefects
                && workOrderObject?.assessmentInformation?.outcome?.adjustedRiskRating === CasePriority.High))
              && !dmcInspectionSorCodes.includes(userChosenSOR))) {
              await Promise.allSettled([
                isCatalystDefectTriageCase ? getContactorAndRepairPriority(originalWoPayload, true)
                  : getContactorAndRepairPriority(originalWoPayload, false),
                getContactorAndRepairPriority(dampMouldWoPayload, false)
              ]).then((res: any) => {
                commonContractorDeterminationResponse = res[0]?.value;
                if (res[1]?.value
                  && commonContractorDeterminationResponse?.determinedContractorResp?.[0]?.id
                  !== CatalistTriageContractorType.CATALYST_TRIAGE_TIER2) {
                  setdmcOriginalWOContractorResponse(res[1]?.value?.determinedContractorResp);
                  setdmcoriginalWOPriorityResponse(res[1]?.value?.updatedRepairPriorityResp);
                }
              });
            }
            else {
              if (!isTriageCase) {
                const originalWOResponses = await getContactorAndRepairPriority(originalWoPayload, false);
                commonContractorDeterminationResponse = originalWOResponses;
              }
              else if ((!eligibilityResponseObject?.statuses?.isInDefects || (eligibilityResponseObject?.statuses?.isInDefects
                && workOrderObject?.assessmentInformation?.outcome?.adjustedRiskRating === CasePriority.High))
                && !dmcInspectionSorCodes.includes(userChosenSOR)) {
                const dampMouldWOResponses = await getContactorAndRepairPriority(dampMouldWoPayload, false);
                setdmcOriginalWOContractorResponse(dampMouldWOResponses?.determinedContractorResp);
                setdmcoriginalWOPriorityResponse(dampMouldWOResponses?.updatedRepairPriorityResp);
              }
            }
          }
          // Handle Catalyst Defect Triage case
          else if (isCatalystDefectTriageCase && workOrderObject?.assessmentInformation?.outcome?.adjustedRiskRating !== CasePriority.High) {
            commonContractorDeterminationResponse = await getContactorAndRepairPriority(originalWoPayload, true);
          } else {
            // Handle normal WO case without Catalyst Defect Triage and without damp/mould WO
            commonContractorDeterminationResponse = await getContactorAndRepairPriority(originalWoPayload, false);
          }
          // Update state with original WO responses
       
          const repairPriority = latestProirity
          if (commonContractorDeterminationResponse) {
            const contractorDetail = commonContractorDeterminationResponse?.determinedContractorResp?.[0];
            const repairPriorityResponse = commonContractorDeterminationResponse?.updatedRepairPriorityResp || repairPriority;
            dispatch(getDeterminedContractorDetails(contractorDetail));
            if (contractorDetail?.name !== "" && contractorDetail?.name !== null) {
              setDisabled(false);
              dispatch(getContractorName(contractorDetail?.name));
              const sorcode = userChosenSOR;
              if (contractorDetail && workOrderObject !== undefined && workOrderObject !== null) {
                try {
                  setIsLoading(true);
                 
                  workOrderObject.isOutOfHours = repairPriorityResponse?.isWorkingHour === 'Y' ? false : true;
                  //to do remove mocking priority afetr testing 
                  workOrderObject.priority = shouldApplyCustomerPreferencesForHHSRS() ? priorityCodeValue : repairPriorityResponse?.repairPriority ?? priorityCodeValue;
                  workOrderObject.contractorName = contractorDetail?.name;
                  if (
                    contractorDetail?.contacts?.[0]?.addresses?.digitalAddresses[0]
                      ?.telecomsAddresses?.length > 0
                  ) {
                    workOrderObject.contractorPhoneNumber =
                      contractorDetail?.contacts?.[0]?.addresses?.digitalAddresses[0]
                        ?.telecomsAddresses[0]?.number;
                  }
                  if (sorcode !== "") workOrderObject.sorCode = sorcode;

                  const siteIdentifier = contractorDetail?.contractorSites
                    ? contractorDetail.contractorSites[0]
                    : null;
                  workOrderObject.contractor = siteIdentifier;

                  userChosenSupplementaryQuestionsVal === "Yes"
                    ? (workOrderObject.isSupplementary = true)
                    : userChosenSupplementaryQuestionsVal === "No"
                      ? (workOrderObject.isSupplementary = false)
                      : (workOrderObject.isSupplementary = null);

                  userChosenVandalismQuestionVal === "Yes" && isVandalismEligible
                    ? (workOrderObject.isVandalism = true)
                    : userChosenVandalismQuestionVal === "No" && isVandalismEligible
                      ? (workOrderObject.isVandalism = false)
                      : (workOrderObject.isVandalism = null);

                  userChosenCovidQuestionVal === "Yes" && covidConfigValue
                    ? (workOrderObject.isCovidSelfIsolated = true)
                    : userChosenCovidQuestionVal === "No" && covidConfigValue
                      ? (workOrderObject.isCovidSelfIsolated = false)
                      : (workOrderObject.isCovidSelfIsolated = null);

                  userChosenDuplicateQuestion === ""
                    ? (workOrderObject.isPotentialDuplicate = false)
                    : (workOrderObject.isPotentialDuplicate = true);
                  userChosenVulnerabilityQuestion !== "" &&
                    userChosenVulnerabilityQuestion !== null &&
                    userChosenVulnerabilityQuestion !== "No"
                    ? (workOrderObject.isVulnerable = true)
                    : (workOrderObject.isVulnerable = false);
                  vulnerabilityAdditionalInformation !== ""
                    ? (workOrderObject.VulnerableResponseText =
                      userChosenVulnerabilityAdditionalInformation)
                    : (workOrderObject.VulnerableResponseText = null);

                  userChosenSOR !== ""
                    ? (workOrderObject.sorCode = userChosenSOR)
                    : (workOrderObject.sorCode = "NA");

                  if (isCatalyst) {
                    workOrderObject.isCatalyst = true;
                  }

                  workOrderObject.isInDefect =
                    eligibilityResponseObject?.statuses?.isInDefects;

                  const _worksOrderRequest = new WorksOrderRequest(workOrderObject);
                  const woRequestParameters =
                    _worksOrderRequest.updateWorkOrderParameter(workOrderObject);
                  const apiResponse = await api.updateWorkOrderRepair(
                    woRequestParameters,
                    workOrderObject.id,
                    "eTag"
                  );

                  dispatch(workOrderRepairObject(workOrderObject));
                } catch (error) {
                  console.error(error);
                  dispatch(showFooter(true));
                  dispatch(saveAlternateEmailValue(""));
                  dispatch(saveEmailCopyRadioValue(""));
                  dispatch(isSendCopyDampMouldReport(false));
                  dispatch(userChosenVulnerabilityAdditionalInformation(""));
                  props.history.push({
                    pathname: "/repairJourneyErrorPage",
                    state: { message: "repair_Journey_Error_Message1" },
                  });
                } finally {
                  setIsLoading(false); // loader spinner stopped
                }
              }
            }
          }
          else {
            setDisabled(false);
          }
        } catch (error) {
          console.error(error);
          dispatch(showFooter(true));
          dispatch(saveAlternateEmailValue(""));
          dispatch(saveEmailCopyRadioValue(""));
          dispatch(isSendCopyDampMouldReport(false))
          dispatch(userChosenVulnerabilityAdditionalInformation(""));
          props.history.push({
            pathname: '/repairJourneyErrorPage',
            state: { message: 'repair_Journey_Error_Message1' }
          });
        } finally {
          setIsLoading(false);
        }
      }
      else {
        setIsLoading(false);
      }
    })();
  }, []);

  return (
    <>
      <HeaderJourney></HeaderJourney>
      <div className="container-fluid parent-footer repair-request p-0" id="confirmation-container">
        <div id="confirmation-main-div ">
          <div id="confirmation-main-div" className="padding-repair">
            <h1 className="header-size" id="confirmation-h1">
              {t("Repair_Details_Head")}
            </h1>
            {blockLoading ? (
              <Loader
                type="ThreeDots"
                color="#00BFFF"
                height={70}
                width={50}
                timeout={5000}
              />
            ) : (BlockMsg === false && blockErrorCode === "E36") ? (
              <Message id="velQues-span2" severity="error" className="warning-msg">
                {t("BlockEMERepairMsg")}
              </Message>) :
              (BlockMsg === false && blockErrorCode !== "E36") ?
                <Message id="velQues-span2" severity="error" className="warning-msg">
                  {t("OrbisBlockMsg1")} <br />
                  {t("OrbisBlockMsg2")}  <strong className="font-bolder">{t("OrbisBlockNumber")}</strong>  {t("OrbisBlockMsg3")}
                </Message> :
                <Message className="info-msg">
                  {t("Repair_Details_Text1")}  {t("Repair_Details_Text2")}
                </Message>
            }
          </div>
          {isLoading ? (
            <div className="padding-repair">
              <Loader
                type="ThreeDots"
                color="#00BFFF"
                height={50}
                width={50}
                timeout={5000}
              /></div>
          ) : (
            <div id="confirmation-div-table">
              {Object.entries(savedAnswerKeys)
                .filter((e: any) => {
                  if (
                    e[1].reduxKey === "mediaAttached" &&
                    featureMedia === "false"
                  ) {
                    return false;
                  }
                  if (workOrderObject?.isEmergency === true &&
                    (e[1].reduxKey === "userChosenVulnerabilityQuestion" && e[1].urlPath === "vulnerabilityquestion")
                  ) {
                    return false;
                  }
                  if ((e[1]?.urlPath === "vandalismquestion" && isVandalismEligible) || e[1]?.urlPath !== "vandalismquestion") {
                    if ((e[1]?.urlPath === "covidquestion" && covidConfigValue) || e[1]?.urlPath !== "covidquestion") {
                      if (e[1]?.urlPath !== "duplicaterepair" || (e[1]?.urlPath === "duplicaterepair" && savedResponses[e[1]?.reduxKey] === "I don't think this is a duplicate")) {
                        return savedResponses[e[1]?.reduxKey];
                      }

                    }
                  }
                })
                .map(renderData)}
              {DmcCheck && (dmcInspectionSorCodes?.includes(workOrderObject.sorCode) || userchosenDMC === "Yes") ? renderDMCData() : ""}
              {shouldApplyCustomerPreferences() && displayDMCEmailReport()}
            </div>
          )}
        </div>

        <div className="col-md-12 marginTop-auto">
          <div className="row m-0 footer-actionbtn">
            <div className="col btn-top padding-repair mb-0" id="confirmation-main-btn">
              <BackModal id="confirm-backmodal" back={backButtonHandler} />
              <ExitModalAndSave
                id="confirmation-exitmodal"
                exit={exitButtonHandler}
                saveDraftAndExit={saveDraftAndExit}
                closeAfterSaving={closeAfterSaving}
              />
            </div>
            <div className="col text-end pt-24 padding-repair">
              <Button
                id="btn_confirmation"
                className="primary-btn"
                onClick={callPageHandler}
                disabled={blockErrorCode === "E36" ? true : disabled}
              >
                {t("continuen_button")}
              </Button>
            </div>
          </div>
        </div>
        {loaderPage && <LoaderPopup className="loader-popup-content" message={t("DMC_SWM")} msg1={t("DMC_SWM1")} />}
      </div>
    </>
  );
};
export default ConfirmationDetails;